import { isDefined } from "@opendaw/lib-std";
export var ProjectMeta;
(function (ProjectMeta) {
    const created = new Date().toISOString();
    ProjectMeta.init = (name = "Untitled") => ({
        artist: "",
        name,
        description: "",
        tags: [],
        created,
        modified: created
    });
    ProjectMeta.copy = (meta) => Object.assign({}, meta);
    // Stored meta from older projects can lack fields (e.g. artist). A bare cast leaves them undefined,
    // which later writes undefined into ProjectMetaBox StringFields and breaks serialization. Merge over defaults.
    ProjectMeta.fromJSON = (json) => {
        if (!isDefined(json) || typeof json !== "object" || Array.isArray(json)) {
            return ProjectMeta.init();
        }
        return Object.assign(ProjectMeta.init(), json);
    };
})(ProjectMeta || (ProjectMeta = {}));
